import React from 'react';
import { connect } from 'react-redux';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';

export const Cabecalho = () => (
  <div className="lista-eventos titulo">
    <div className="row cabecalho-desktop">
      <div className="col-12 col-sm-12 col-md-3">Data e Hora</div>
      <div className="col-12 col-sm-12 col-md-3">Situação</div>
      <div className="col-12 col-sm-12 col-md-3">Usuário</div>
      <div className="col-12 col-sm-12 col-md-3">Observação</div>
    </div>
  </div>
);

export class ModalHistoricoEncomenda extends React.Component {
  exibirHistorico () {
    if (this.props.historicos) {
      return this.props.historicos.map(historico => <div className="lista-eventos" key={`${historico.cod}-${historico.dataHora}`}>
        <div className="row conteudo-desktop">
          <div className="col-12 col-sm-12 col-md-3">
            <div id="data-hora" className="texto"><p>{historico.dataHora}</p>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-3">
            <div id="evento" className="texto">
              <p>{historico.descricaoSituacao}</p>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-3">
            <div id="usuario" className="texto">
              <p>{capitalizarTodasPrimeirasLetras(historico.nomeUsuario)}</p>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-3">
            <div id="documentos" className="texto">
              <p>{historico.observacao ? historico.observacao : '-'}</p>
            </div>
          </div>
        </div>
      </div>)
    }
    return ''
  }

  render () {
    return (

      <div className="modal fade show" role="dialog"
           id="modalHistoricoEncomenda" aria-labelledby="modalHistoricoEncomenda" aria-hidden="true" data-backdrop="static">
        <div className="modal-dialog modal-info modal-xl modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title">Pedido {this.props.idPedido}</h3>
              <button type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close">
                <i className="material-icons">
                  &#xe5cd;
                </i>
              </button>
            </div>
            <div className="modal-body corpo-modal">
              <Cabecalho/>
              {this.exibirHistorico()}
            </div>
          </div>
        </div>
      </div>

    )
  }
}

export function mapStateToProps (state) {
  return {
    empresaSelecionada: state.empresaSelecionada,
  }
}

export default connect(mapStateToProps,
  {})(ModalHistoricoEncomenda)
